module.exports = __webpack_public_path__ + "assets/img/home-swiper-5.91e88397.png";